// extracted by mini-css-extract-plugin
module.exports = {"serverError_content":"serverError_serverError_content__dAD0M","text":"serverError_text__1Jw5s","goHome":"serverError_goHome__MiJhT","btn":"serverError_btn__1H7wY"};